import { produce } from 'immer'

import { normalizeFilters } from '@user/components/Filters'

import type {
  ActivitySummaryDTO,
  ActivitySummaryFilterSet,
} from '../../../typings'
import type { State } from '../../typings'

export const setActivitySummaryFiltersProducer = produce<
  State,
  [ActivitySummaryFilterSet]
>((draft, payload) => {
  draft.tableState.paginationState.page = 0

  draft.filterSet = normalizeFilters<
    ActivitySummaryDTO,
    ActivitySummaryFilterSet
  >(payload)
})
